import { Box, Button, Card, Typography, useTheme } from "@mui/material";
import { Line } from "../Line";
import { SumaryItem } from "./components/SumaryItem";

type SumaryOrderProps = {
  total: number;
  variants: any[];
  onClick?: () => void;
};
export const SumaryOrder = ({ total, variants, onClick }: SumaryOrderProps) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        padding: 5,
        minHeight: 310,
        mb: 3,
        backgroundColor: theme.palette.background.default,
        borderRadius: 3,
        boxShadow: `${theme.palette.customColor?.light} 0px 0px 3px`,
      }}
    >
      <Typography
        fontSize={16}
        fontWeight={600}
        variant="h6"
        paddingBottom={5}
        sx={{ color: theme.palette.secondary.main }}
      >
        Order summary
      </Typography>
      <Box display="flex" flexDirection="column" gap={5}>
        <SumaryItem
          fontWeightLabel={400}
          colorLabel={theme.palette.secondary[100]}
          label="Subtotal"
          colorValue={theme.palette.secondary.main}
          value={`$${total.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`}
        />
        <SumaryItem
          fontWeightLabel={400}
          colorLabel={theme.palette.secondary[100]}
          label="Shipping"
          colorValue={theme.palette.secondary.main}
          value={total >= 150 ? "Free" : "Not free"}
        />
      </Box>

      <Box display="flex" flexDirection="column" gap={3}>
        <Line />
        <SumaryItem
          fontWeightLabel={600}
          colorLabel={theme.palette.secondary.main}
          label="Total"
          colorValue={theme.palette.primary[800]}
          value={`$${total.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`}
        />
        <Line />
        <Typography
          textAlign="center"
          sx={{
            color:
              total < 150
                ? theme.palette.secondary[100]
                : theme.palette.success.main,
          }}
          variant="caption"
        >
          {total <= 0
            ? "Spend $150 to get free shipping"
            : total < 150
            ? `You're $${150 - total} away from free shipping`
            : "You got free shipping!"}
        </Typography>
      </Box>
      <Button
        onClick={onClick}
        disableElevation
        fullWidth
        disabled={!variants.length}
        color="secondary"
        sx={{ p: 3 }}
        variant="contained"
      >
        Check out
      </Button>
    </Card>
  );
};
